import React from 'react';
import PropTypes from 'prop-types';

import { AppContext } from '@prisjakt/ui-app-context';
import PanelHeader from '@prisjakt/ui-panel-header';
import ShopCard from '@prisjakt/ui-shop-card';
import Grid from '@prisjakt/ui-grid';

import withElastic from '../data/with-elastic';

import MatchMedia from '../../../../components/match-media';
import CampaignStorePopup from '../campaign-store-popup';

import * as S from './styles';

const buildQuery = () => ({
  size: 0,
  aggs: {
    stores: {
      terms: {
        field: 'store.id',
        size: 20,
        order: { total_rank: 'desc' },
      },
      aggs: {
        total_rank: { sum: { field: 'rank' } },
        top_hits: {
          top_hits: {
            _source: {
              includes: [
                'id',
                'store.id',
                'store.featured',
                'store.logo',
                'store.name',
                'store.external_uri',
              ],
            },
            size: 1,
          },
        },
      },
    },
  },
});

class PopularStores extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showCampaignStorePopup: false,
    };
  }

  toggleStoreCampaignItemsPopup(store) {
    this.setState(prevState => ({
      showCampaignStorePopup: prevState.showCampaignStorePopup ? false : store,
    }));
  }

  render() {
    const { t } = this.context;
    const { data, dailyDeals, router } = this.props;

    return (
      <MatchMedia
        debounce={150}
        serverSideRender={{ numberOfStores: 20, dealCount: 8 }}
        matches={[
          {
            mediaQuery: '(max-width: 640px)',
            values: { numberOfStores: 4, dealCount: 4 },
          },
          {
            mediaQuery: '(min-width: 640px)',
            values: { numberOfStores: 20, dealCount: 8 },
          },
        ]}
      >
        {({ numberOfStores, dealCount }) => (
          <S.Wrapper>
            <PanelHeader
              title={t('campaigns', 'inactive-campaign.popular-stores')}
            >
              <S.ViewAllLink to={dailyDeals.web_uri.responsive}>
                {t('campaigns', 'link.view-all')}
              </S.ViewAllLink>
            </PanelHeader>
            <Grid
              blocks={{
                xs: 2,
                sm: 2,
                md: 3,
                lg: 4,
                xl: 4,
              }}
            >
              {data &&
                data.aggregations.stores.buckets
                  .slice(0, numberOfStores)
                  .map(hit => {
                    /* eslint-disable-next-line no-underscore-dangle */
                    const shop = hit.top_hits.hits.hits[0]._source.store;
                    return (
                      <ShopCard
                        key={hit.key}
                        name={shop.name}
                        featured={shop.featured}
                        logo={
                          shop.logo && (shop.logo['176'] || shop.logo['96'])
                        }
                        onClick={() => this.toggleStoreCampaignItemsPopup(shop)}
                      />
                    );
                  })}
            </Grid>
            {this.state.showCampaignStorePopup && dailyDeals && (
              <CampaignStorePopup
                router={router}
                campaign={dailyDeals}
                shop={this.state.showCampaignStorePopup}
                dealCount={dealCount}
                onRequestClose={() => this.toggleStoreCampaignItemsPopup()}
              />
            )}
          </S.Wrapper>
        )}
      </MatchMedia>
    );
  }
}

const { number, object } = PropTypes;

PopularStores.propTypes = {
  campaignId: number.isRequired,
  data: object, // eslint-disable-line react/forbid-prop-types,
  dailyDeals: object, // eslint-disable-line react/forbid-prop-types,
  router: object.isRequired, // eslint-disable-line react/forbid-prop-types,
};

PopularStores.defaultProps = { data: null, dailyDeals: undefined };

PopularStores.contextType = AppContext;

export default withElastic(buildQuery, 1500)(PopularStores);
